import { VpIcon, VpLoader } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

import { SpoSmSheetResponse } from '@spo/types';
import { useTeamMembers } from '../../hooks/useTeamMembers';
import { SmInfoContainer } from '../SmInfoContainer';
import { SmInfoDisplay } from '../smInfoDisplay';

export interface SmTeamMembersProps {
  sm: SpoSmSheetResponse | undefined;
}

export const SmTeamMembers = ({ sm }: SmTeamMembersProps) => {
  const { t } = useTranslation();

  const memberIds = [
    sm?.productManagerUid,
    sm?.productEngineerUid,
    sm?.productDesignerUid,
  ].filter((member) => !!member) as string[];

  const { data: teamMembersData, isFetching } = useTeamMembers(memberIds);

  const displayMember = (memberUid: string | null | undefined) => {
    if (!memberUid) {
      return t('sm-info.to-be-defined');
    }
    const matchingName = teamMembersData?.find(
      (apiMember) => apiMember.uid === memberUid,
    );
    const displayName = matchingName
      ? `${matchingName?.given_name} ${matchingName?.sn}`
      : memberUid;
    return displayName ?? t('sm-info.to-be-defined');
  };

  return (
    <SmInfoContainer
      title={t('sm-info.team-members')}
      icon={<VpIcon name="user" />}
    >
      {isFetching ? (
        <VpLoader role="marquee" aria-label="Content is loading..." />
      ) : (
        <>
          <SmInfoDisplay
            label={t('sm-info.product-manager')}
            isLoading={isFetching}
          >
            {displayMember(sm?.productManagerUid)}
          </SmInfoDisplay>
          <SmInfoDisplay
            label={t('sm-info.product-engineer')}
            isLoading={isFetching}
          >
            {displayMember(sm?.productEngineerUid)}
          </SmInfoDisplay>
          <SmInfoDisplay
            label={t('sm-info.product-designer')}
            isLoading={isFetching}
          >
            {displayMember(sm?.productDesignerUid)}
          </SmInfoDisplay>
        </>
      )}
    </SmInfoContainer>
  );
};
